export const RULER_HEIGHT_IN_PX = 40;
export const ROW_HEIGHT_IN_PX = 52;
export const ELEMENT_HEIGHT_IN_PX = 48;
export const DEFAULT_ZOOM_LEVEL = 1;
export const TIMELINE_FIXED_HEIGHT_IN_PX = 350;
